export const APP_URL = 'https://www.cushionpros.com'
export const API_URL = 'https://www.cushionpros.com/woo'
export const DESIGNER_STEPS = [
  'Select Type',
  'Shape',
  'Dimensions',
  'Fabric',
  'Style',
  'Fasteners',
  'Filling',
]
export const DESIGNER_STEPS_DEEP_SEATING = [
  'Select Type',
  'Set',
  'Shape',
  'Dimensions',
  'Fabric',
  'Style',
  'Fasteners',
  'Filling',
]
export const DESIGNER_STEPS_CUSTOM_DEEP_SEATING = [
  'Select Type',
  'Set',
  'Dimensions',
  'Fabric',
  'Style',
  'Fasteners',
  'Filling',
]
export const DESIGNER_STEPS_FILLING_ONLY = ['Select Type', 'Shape', 'Dimensions', 'Filling']
export const DESIGNER_STEPS_PILLOW = ['Select Type', 'Dimensions', 'Fabric', 'Style', 'Filling']
export const DESIGNER_STEPS_URLS = [
  '/type',
  '/shape',
  '/dimensions',
  '/fabric',
  '/style',
  '/fasteners',
  '/filling',
]
export const DESIGNER_STEPS_URLS_DEEP_SEATING = [
  '/type',
  '/set',
  '/shape',
  '/dimensions',
  '/fabric',
  '/style',
  '/fasteners',
  '/filling',
]
export const DESIGNER_STEPS_URLS_CUSTOM_DEEP_SEATING = [
  '/type',
  '/set',
  '/dimensions',
  '/fabric',
  '/style',
  '/fasteners',
  '/filling',
]
export const DESIGNER_STEPS_URLS_FILLING_ONLY = ['/type', '/shape', '/dimensions', '/filling']
export const DESIGNER_STEPS_URLS_PILLOW = ['/type', '/dimensions', '/fabric', '/style', '/filling']
export const PAGE_PREFIX = '/cd'
export const DESIGNER_HEADER_TEXTS = [
  'Select the furniture type for your cushion below.',
  'Shape Selection',
  'Select Dimensions',
  'Select Cushion Fabric',
  'Select Style',
  'Select Cushion Fasteners',
  'Select Cushion Filling',
]
export const DESIGNER_HEADER_TEXTS_FILLING_ONLY = [
  'Select the furniture type for your cushion below.',
  'Shape Selection',
  'Select Dimensions',
  'Select Cushion Filling',
]
export const DESIGNER_HEADER_TEXTS_DEEP_SEATING = [
  'Select the furniture type for your cushion below.',
  'Select the furniture set',
  'Shape Selection',
  'Select Dimensions',
  'Select Cushion Fabric',
  'Select Style',
  'Select Cushion Fasteners',
  'Select Cushion Filling',
]
export const DESIGNER_HEADER_TEXTS_CUSTOM_DEEP_SEATING = [
  'Select the furniture type for your cushion below.',
  'Select the furniture set',
  'Select Dimensions',
  'Select Cushion Fabric',
  'Select Style',
  'Select Cushion Fasteners',
  'Select Cushion Filling',
]
export const DESIGNER_HEADER_TEXTS_PILLOW = [
  'Select the furniture type for your cushion below.',
  'Select Dimensions',
  'Select Cushion Fabric',
  'Select Style',
  'Select Cushion Filling',
]
export const FASTENER_PLACEMENT_RECTANGLE = {
  1: 'placement_bottom_indented',
  2: 'placement_bottom_corners',
  3: 'placement_left_center',
  4: 'placement_top_corners',
  5: 'placement_top_indented',
  '3-mirror': 'placement_right_center',
}

export const FASTENER_PLACEMENT_SQUARE = {
  1: 'placement_bottom_center',
  2: 'placement_bottom_corners',
  3: 'placement_sides_center',
  4: 'placement_top_corners',
  '1-mirror': 'placement_top_center',
}

export const DIMENSION_ATTRIBUTES = {
  11: 'width',
  10: 'thickness',
  9: 'depth',
  16: 'front_width',
  17: 'back_width',
  37: 'section_1',
  20: 'section_2',
  21: 'section_3',
  22: 'section_4',
  23: 'back_thickness',
  24: 'seat_thickness',
  25: 'back_height',
  27: 'center_depth',
  44: 'height',
  45: 'diameter',
}

export const SHAPE_ATTRIBUTES_MAP = {
  //squared corners
  29: [10, 11, 9],
  //rounded corners
  30: [10, 11, 9],
  //rounded front
  727: [10, 11, 9],
  //rounded back
  728: [10, 11, 9],
  //trapezoid
  729: [10, 16, 27, 17],
  //rectangle 1 break
  734: [10, 37, 20, 11],
  //rectangle 2 breaks
  735: [10, 37, 20, 21, 11],
  //rectangle 3 breaks
  736: [10, 37, 20, 21, 22, 11],
  //rounded rectangle 1 break
  737: [10, 37, 20, 11],
  //rounded rectangle 2 breaks
  738: [10, 37, 20, 21, 11],
  //rounded rectangle 3 breaks
  739: [10, 37, 20, 21, 22, 11],
  //rounded top
  787: [10, 11, 9],
  //rounded bottom
  788: [10, 11, 9],
  //custom corners
  859: [10, 11, 9],
  // Circle
  880: [10, 11],
  // Toss
  168: [44, 11],
  // Bolster
  11858: [11, 45],
  // Lumbar
  11860: [44, 11],
  // Loveseat
  11864: [24, 11, 9, 25, 23],
  // Chair with back
  11569: [24, 11, 9, 25, 23],
  // Chair
  11786: [24, 11, 9, 25, 23],
  // sofa - same as loveseat
  12090: [24, 11, 9, 25, 23],
  //ottoman
  166: [24, 11, 9],
}

export const ITEM_ORDERING = {
  CUSHION_DESIGNER_TYPES: [
    11660, 11658, 11568, 12107, 11786, 12072, 166, 11864, 12090, 11741, 168, 11860, 11858, 13101,
  ],
  SETS: [883, 875, 860, 882, 876, 881, 877, 782],
  SHAPES: [29, 788, 787, 30, 727, 728, 729, 880, 734, 735, 736, 737, 738, 739],
  STYLES: [789, 741, 790, 742],
  FILLINGS: [722, 723, 724, 725, 873, 874, 726],
}
